import { Link } from '@ecomm/framework'
import classNames from 'classnames'

import type { Locale } from '@ecomm/utils'
import { getPackagesMenuLeftItems } from '../data'

type PackagesMenuLeftItemsProps = {
  readonly locale: Locale
  readonly handleClick: (text: string) => () => void
}

export function PackagesMenuLeftItems({
  locale,
  handleClick
}: PackagesMenuLeftItemsProps) {
  return (
    <div className="w-full px-4 min-[1126px]:w-auto min-[1126px]:px-0">
      {getPackagesMenuLeftItems(locale).map((item, i) => (
        <div
          className="first-of-type:mt-4 last-of-type:mb-3 min-[1126px]:!mb-6 first-of-type:min-[1126px]:mt-2 [&:not(:last-of-type)]:mb-8"
          key={i}
        >
          {item.caption ? (
            <small className="block">{item.caption}</small>
          ) : null}
          <Link
            className={classNames(
              'text-neutral-black block w-full text-base no-underline hover:underline min-[1126px]:w-auto min-[1126px]:font-medium'
            )}
            onClick={handleClick(item.text)}
            to={item.url}
          >
            {item.text}
          </Link>
        </div>
      ))}
    </div>
  )
}
